export const getCurrentUrlWithoutParameters = () => {
  const url = window.location.href.split('?')[0]
  return url
}